"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const minus = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-minus` : '') + (description ? ` desc-minus` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-minus"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-minus"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.3125 11H1.6875L1.57591 11.0075C1.09274 11.0783 0.75 11.5031 0.75 12C0.75 12.5477 1.16464 13 1.6875 13H22.3125L22.4241 12.9925C22.9073 12.9217 23.25 12.4969 23.25 12C23.25 11.4523 22.8354 11 22.3125 11Z",
    fill: "inherit"
  }));
};
var _default = exports.default = minus;